import * as JsStore from 'jsstore';
import OfflineSchema from '../dbTable/offlineSchema';
import OfflineSyncSchema from '../dbTable/offlineSyncSchema';

export const idbCon = new JsStore.Connection(new Worker('..' + process.env.PUBLIC_URL + '/resource/jsstore/jsstore.worker.js'));

export const dbName = 'TeamLead';

const GetDatabase = () => {
   return  {
        name: dbName,
        tables: [OfflineSchema, OfflineSyncSchema]
    };
};

export const InitJsStore = () => {
    try {
        const dataBase = GetDatabase();
        idbCon.initDb(dataBase);
    }
    catch (ex) {
        console.error(ex);
    }
};
